import React, { useEffect, Suspense } from "react";
import Aos from "aos";
import 'aos/dist/aos.css'
import Roster from '../components/Roster'
import Founders from "../components/Founders";
import Labs from "../components/Labs";
import ContentCreator from "../components/ContentCreator";
import BlackMafia from "../components/BlackMafia";

const Crew = () => {

  useEffect(() => {
    Aos.init();
  }, [])

  return (
    <main>
      <div className="crew-title">
        <h1 className="">Rencontrez les personnes qui font l'essence même de BMS</h1>
      </div>
      <div className="separator w-full max-w-6xl mx-auto px-4">
        <hr className="border-t-2 border-[#e0e0e0] opacity-75" />
      </div>
      <section className="founders">
        <h1 className="text-center text-4xl font-bold">Les Fondateurs de BMS</h1>
        <Founders />
      </section>
      <section className="roster">
        <h1 className="text-center text-4xl font-bold">Nos joueurs</h1>
        <Roster />
      </section>
      <section className="labo">
        <h1 className="text-center text-4xl font-bold text-[#be185d]">Le labo</h1>
        <Labs/>
      </section>
      <section className="content-creator">
        <h1 className="text-center text-4xl font-bold">Nos créateurs de contenu</h1>
        <ContentCreator />
      </section>
      <section className="black-mafia">
        <h1 className="text-center text-4xl font-bold text-[#be185d]">La Black Mafia</h1>
          <BlackMafia />
      </section>
    </main>
  );
}

export default Crew;